import React, { useContext, useEffect, useReducer, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useHelps from "../hooks/useHelps";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import Schedule from "@material-ui/icons/Schedule";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CakeIcon from "@material-ui/icons/Cake";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import BusinessIcon from "@material-ui/icons/Business";

import {
  AllInclusive,
  AttachFile,
  Dashboard,
  Description,
  DeviceHubOutlined,
  GridOn,
  PhonelinkSetup,
} from "@material-ui/icons";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { useActiveMenu } from "../context/ActiveMenuContext";

import { Can } from "../components/Can";

import { isArray } from "lodash";
import api from "../services/api";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import useVersion from "../hooks/useVersion";
import { i18n } from "../translate/i18n";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import TimelineIcon from "@material-ui/icons/Timeline";
import LinkIcon from "@material-ui/icons/Link";

import useCompanySettings from "../hooks/useSettings/companySettings";

const useStyles = makeStyles((theme) => ({
  listItem: {
    height: "48px",
    borderRadius: "10px",
    margin: "2px 8px",
    width: "auto",
    "&.active, &:hover": {
      background: "rgba(91,45,142,0.08)",
      transition: "background 0.25s cubic-bezier(0.4,0,0.2,1)",
    },
    "&:hover $iconHoverActive": {
      background: "linear-gradient(135deg, #5B2D8E, #7C3AED)",
      color: "#fff",
      transform: "scale(1.05)",
    },
    "&:hover $listItemText": {
      color: "#5B2D8E",
      fontWeight: 600,
    },
    transition: "all 0.25s cubic-bezier(0.4,0,0.2,1)",
  },

  listItemText: {
    fontSize: "14px",
    color: theme.mode === "light" ? "#334155" : "#cbd5e1",
    transition: "color 0.25s cubic-bezier(0.4,0,0.2,1)",
    fontWeight: 500,
    "& .MuiTypography-root": {
      fontFamily: "'Inter', 'Roboto', sans-serif",
      fontSize: "13px",
      fontWeight: 500,
      color: theme.mode === "light" ? "#334155" : "#cbd5e1",
    }
  },

  avatarActive: {
    backgroundColor: "transparent",
  },

  avatarHover: {
    backgroundColor: "transparent",
  },

  iconHoverActive: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "10px",
    height: 36,
    width: 36,
    backgroundColor: theme.mode === "light"
      ? "rgba(91,45,142,0.08)"
      : "rgba(91,45,142,0.10)",
    color: theme.mode === "light" ? "#5B2D8E" : "#7C3AED",
    transition: "all 0.25s cubic-bezier(0.4,0,0.2,1)",
    "&:hover, &.active": {
      background: "linear-gradient(135deg, #5B2D8E, #7C3AED)",
      color: "#fff",
      boxShadow: "0 6px 16px rgba(91,45,142,0.35)",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.4rem",
      transition: "transform 0.3s ease",
    },
    "&:hover .MuiSvgIcon-root": {
      transform: "scale(1.1)",
    }
  },

  // Badge melhorado mas mantendo funcionalidade
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#ef4444",
      color: "#fff",
      fontSize: "0.75rem",
      fontWeight: 600,
      animation: "$pulse 2s infinite",
    }
  },

  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.7,
    }
  },

  // Melhorias para submenus mantendo estrutura original
  submenuContainer: {
    backgroundColor: theme.mode === "light"
      ? "rgba(0, 0, 0, 0.02)"
      : "rgba(255, 255, 255, 0.02)",
  },

  // Tooltip melhorado
  customTooltip: {
    backgroundColor: theme.mode === "light" ? "#1e293b" : "#374151",
    color: "#fff",
    fontSize: "0.875rem",
    fontWeight: 500,
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    "& .MuiTooltip-arrow": {
      color: theme.mode === "light" ? "#1e293b" : "#374151",
    }
  },

  // Versão com destaque sutil
  versionContainer: {
    textAlign: "center",
    padding: "12px 16px",
    color: "#7C3AED",
    fontSize: "11px",
    fontWeight: "bold",
    borderTop: "1px solid rgba(91,45,142,0.15)",
    marginTop: "auto",
  },

  // Seções de administração com destaque sutil
  adminSection: {
    "& .MuiListSubheader-root": {
      color: "#7C3AED",
      fontSize: "10px",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.3em",
      padding: "16px 16px 8px",
    }
  },

  // Efeitos suaves para expand/collapse
  expandIcon: {
    transition: "transform 0.3s ease",
    color: theme.palette.primary.main, // Usa cor do tema
    "&.expanded": {
      transform: "rotate(180deg)",
    }
  },

  // Menu container com melhorias sutis
  menuContainer: {
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.mode === "light"
        ? "rgba(0, 0, 0, 0.1)"
        : "rgba(255, 255, 255, 0.1)",
      borderRadius: "3px",
      "&:hover": {
        background: theme.mode === "light"
          ? "rgba(0, 0, 0, 0.2)"
          : "rgba(255, 255, 255, 0.2)",
      }
    },
  },

  // Estado ativo melhorado mantendo funcionalidade original
  activeItem: {
    "& $iconHoverActive": {
      background: "linear-gradient(135deg, #5B2D8E, #7C3AED)",
      color: "#fff",
      boxShadow: "0 6px 16px rgba(91,45,142,0.35)",
    },
    "& $listItemText .MuiTypography-root": {
      color: "#5B2D8E",
      fontWeight: 700,
    }
  }
}));

function ListItemLink(props) {
  const { icon, primary, to, tooltip, showBadge } = props;
  const classes = useStyles();
  const { activeMenu } = useActiveMenu();
  const location = useLocation();
  const isActive = activeMenu === to || location.pathname === to;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  const ConditionalTooltip = ({ children, tooltipEnabled }) =>
    tooltipEnabled ? (
      <Tooltip title={primary} placement="right">
        {children}
      </Tooltip>
    ) : (
      children
    );

  return (
    <ConditionalTooltip tooltipEnabled={!!tooltip}>
      <li>
        <ListItem button component={renderLink} className={classes.listItem}>
          {icon ? (
            <ListItemIcon>
              {showBadge ? (
                <Badge
                  badgeContent="!"
                  color="error"
                  overlap="circular"
                  className={classes.badge}
                >
                  <Avatar
                    className={`${classes.iconHoverActive} ${isActive ? "active" : ""
                      }`}
                  >
                    {icon}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  className={`${classes.iconHoverActive} ${isActive ? "active" : ""
                    }`}
                >
                  {icon}
                </Avatar>
              )}
            </ListItemIcon>
          ) : null}
          <ListItemText
            primary={
              <Typography className={classes.listItemText}>
                {primary}
              </Typography>
            }
          />
        </ListItem>
      </li>
    </ConditionalTooltip>
  );
}

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

const MainListItems = ({ collapsed, drawerClose }) => {
  const theme = useTheme();
  const classes = useStyles();
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, socket } = useContext(AuthContext);

  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false);
  const [openDashboardSubmenu, setOpenDashboardSubmenu] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);

  // novas features
  const [showSchedules, setShowSchedules] = useState(false);
  const [showInternalChat, setShowInternalChat] = useState(false);
  const [showExternalApi, setShowExternalApi] = useState(false);

  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  const [version, setVersion] = useState(false);
  const [managementHover, setManagementHover] = useState(false);
  const [campaignHover, setCampaignHover] = useState(false);
  const { list } = useHelps(); // INSERIR
  const [hasHelps, setHasHelps] = useState(false);

  const [openFlowSubmenu, setOpenFlowSubmenu] = useState(false);
  const [flowHover, setFlowHover] = useState(false);

  const { get: getSetting } = useCompanySettings();
  const [showWallets, setShowWallets] = useState(false);

  const isFlowbuilderRouteActive =
    location.pathname.startsWith("/phrase-lists");
  location.pathname.startsWith("/flowbuilders");

  useEffect(() => {
    // INSERIR ESSE EFFECT INTEIRO
    async function checkHelps() {
      const helps = await list();
      setHasHelps(helps.length > 0);
    }
    checkHelps();
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const setting = await getSetting(
          {
            "column": "DirectTicketsToWallets"
          }
        );

        setShowWallets(setting.DirectTicketsToWallets);

      } catch (err) {
        toastError(err);
      }
    }

    fetchSettings();
  }, [setShowWallets]);

  const isManagementActive =
    location.pathname === "/" ||
    location.pathname.startsWith("/reports") ||
    location.pathname.startsWith("/moments");

  const isCampaignRouteActive =
    location.pathname === "/campaigns" ||
    location.pathname.startsWith("/contact-lists") ||
    location.pathname.startsWith("/campaigns-config");

  useEffect(() => {
    if (location.pathname.startsWith("/tickets")) {
      setActiveMenu("/tickets");
    } else {
      setActiveMenu("");
    }
  }, [location, setActiveMenu]);

  const { getPlanCompany } = usePlans();

  const { getVersion } = useVersion();

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowCampaigns(planConfigs.plan.useCampaigns);
      setShowKanban(planConfigs.plan.useKanban);
      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowInternalChat(planConfigs.plan.useInternalChat);
      setShowExternalApi(planConfigs.plan.useExternalApi);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    if (user.id && socket && typeof socket.on === 'function') {
      const companyId = user.companyId;

      const onCompanyChatMainListItems = (data) => {
        if (data.action === "new-message") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
      };

      const eventName = `company-${companyId}-chat`;

      socket.on(eventName, onCompanyChatMainListItems);

      return () => {
        if (socket && typeof socket.off === 'function') {
          socket.off(eventName, onCompanyChatMainListItems);
        }
      };
    }
  }, [socket, user.id, user.companyId]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  // useEffect(() => {
  //   if (localStorage.getItem("cshow")) {
  //     setShowCampaigns(true);
  //   }
  // }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  // Helpers para etiquetas de sección
  const SectionLabel = ({ label }) => !collapsed ? (
    <Typography style={{
      fontSize: "10px", fontWeight: 700, letterSpacing: "0.12em",
      textTransform: "uppercase", color: "#7C3AED",
      padding: "16px 16px 4px", display: "block",
    }}>
      {label}
    </Typography>
  ) : <Divider style={{ margin: "8px 4px", opacity: 0.3 }} />;

  const subBg = { backgroundColor: theme.mode === "light" ? "rgba(91,45,142,0.04)" : "rgba(91,45,142,0.06)" };

  return (
    <div onClick={drawerClose}>

      {/* ══════════════════════════════
          SECCIÓN 1 — PRINCIPAL
      ══════════════════════════════ */}
      <SectionLabel label="Principal" />

      <ListItemLink
        to="/tickets"
        primary={i18n.t("mainDrawer.listItems.tickets")}
        icon={<WhatsAppIcon />}
        tooltip={collapsed}
      />

      {user.showContacts === "enabled" && (
        <ListItemLink
          to="/contacts"
          primary={i18n.t("mainDrawer.listItems.contacts")}
          icon={<ContactPhoneOutlinedIcon />}
          tooltip={collapsed}
        />
      )}

      {showKanban && (
        <ListItemLink
          to="/kanban"
          primary={i18n.t("mainDrawer.listItems.kanban")}
          icon={<ViewColumnIcon />}
          tooltip={collapsed}
        />
      )}

      {showInternalChat && (
        <ListItemLink
          to="/chats"
          primary={i18n.t("mainDrawer.listItems.chats")}
          icon={
            <Badge color="secondary" variant="dot" invisible={invisible}>
              <ForumIcon />
            </Badge>
          }
          tooltip={collapsed}
        />
      )}

      {/* ══════════════════════════════
          SECCIÓN 2 — HERRAMIENTAS
      ══════════════════════════════ */}
      <SectionLabel label="Herramientas" />

      {showSchedules && (
        <ListItemLink
          to="/schedules"
          primary={i18n.t("mainDrawer.listItems.schedules")}
          icon={<Schedule />}
          tooltip={collapsed}
        />
      )}

      <ListItemLink
        to="/quick-messages"
        primary={i18n.t("mainDrawer.listItems.quickMessages")}
        icon={<FlashOnIcon />}
        tooltip={collapsed}
      />

      <ListItemLink
        to="/tags"
        primary={i18n.t("mainDrawer.listItems.tags")}
        icon={<LocalOfferIcon />}
        tooltip={collapsed}
      />

      <Can
        role={user.profile === "user" && user.showDashboard === "enabled" ? "admin" : user.profile}
        perform="drawer-admin-items:view"
        yes={() => (
          <>
            <ListItemLink
              to="/reports"
              primary={i18n.t("mainDrawer.listItems.reports")}
              icon={<Description />}
              tooltip={collapsed}
            />
            <Can
              role={user.profile === "user" && user.allowRealTime === "enabled" ? "admin" : user.profile}
              perform="drawer-admin-items:view"
              yes={() => (
                <ListItemLink
                  to="/moments"
                  primary={i18n.t("mainDrawer.listItems.chatsTempoReal")}
                  icon={<GridOn />}
                  tooltip={collapsed}
                />
              )}
            />
          </>
        )}
      />

      {user?.showCampaign === "enabled" && showCampaigns && (
        <>
          <Tooltip title={collapsed ? i18n.t("mainDrawer.listItems.campaigns") : ""} placement="right">
            <ListItem dense button
              onClick={(e) => { e.stopPropagation(); setOpenCampaignSubmenu((prev) => !prev); }}
              onMouseEnter={() => setCampaignHover(true)}
              onMouseLeave={() => setCampaignHover(false)}
            >
              <ListItemIcon>
                <Avatar className={`${classes.iconHoverActive} ${isCampaignRouteActive || campaignHover ? "active" : ""}`}>
                  <RecordVoiceOverIcon />
                </Avatar>
              </ListItemIcon>
              <ListItemText primary={<Typography className={classes.listItemText}>{i18n.t("mainDrawer.listItems.campaigns")}</Typography>} />
              {openCampaignSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
          </Tooltip>
          <Collapse in={openCampaignSubmenu} timeout="auto" unmountOnExit style={subBg}>
            <List dense component="div" disablePadding>
              <ListItemLink to="/campaigns" primary={i18n.t("campaigns.subMenus.list")} icon={<ListIcon />} tooltip={collapsed} />
              <ListItemLink to="/contact-lists" primary={i18n.t("campaigns.subMenus.listContacts")} icon={<PeopleIcon />} tooltip={collapsed} />
              <ListItemLink to="/campaigns-config" primary={i18n.t("campaigns.subMenus.settings")} icon={<SettingsOutlinedIcon />} tooltip={collapsed} />
              <Can role={user.profile} perform="dashboard:view"
                yes={() => <ListItemLink to="/files" primary={i18n.t("mainDrawer.listItems.files")} icon={<AttachFile />} tooltip={collapsed} />}
              />
            </List>
          </Collapse>
        </>
      )}

      {user.showFlow === "enabled" && (
        <>
          <Tooltip title={collapsed ? "Automatizaciones" : ""} placement="right">
            <ListItem dense button
              onClick={(e) => { e.stopPropagation(); setOpenFlowSubmenu((prev) => !prev); }}
              onMouseEnter={() => setFlowHover(true)}
              onMouseLeave={() => setFlowHover(false)}
            >
              <ListItemIcon>
                <Avatar className={`${classes.iconHoverActive} ${isFlowbuilderRouteActive || flowHover ? "active" : ""}`}>
                  <LinkIcon />
                </Avatar>
              </ListItemIcon>
              <ListItemText primary={<Typography className={classes.listItemText}>Automatizaciones</Typography>} />
              {openFlowSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
          </Tooltip>
          <Collapse in={openFlowSubmenu} timeout="auto" unmountOnExit style={subBg}>
            <List dense component="div" disablePadding>
              <ListItemLink to="/phrase-lists" primary="Frases automáticas" icon={<EventAvailableIcon />} tooltip={collapsed} />
              <ListItemLink to="/flowbuilders" primary="Flujo de conversación" icon={<TimelineIcon />} tooltip={collapsed} />
            </List>
          </Collapse>
        </>
      )}

      {/* ══════════════════════════════
          SECCIÓN 3 — ADMINISTRACIÓN
          (solo admins)
      ══════════════════════════════ */}
      <Can
        role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
        perform="dashboard:view"
        yes={() => (
          <>
            <SectionLabel label="Administración" />

            <Can
              role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
              perform="drawer-admin-items:view"
              yes={() => (
                <ListItemLink
                  to="/connections"
                  primary={i18n.t("mainDrawer.listItems.connections")}
                  icon={<SyncAltIcon />}
                  showBadge={connectionWarning}
                  tooltip={collapsed}
                />
              )}
            />

            <Can role={user.profile} perform="dashboard:view"
              yes={() => <ListItemLink to="/users" primary={i18n.t("mainDrawer.listItems.users")} icon={<PeopleAltOutlinedIcon />} tooltip={collapsed} />}
            />

            <Can role={user.profile} perform="dashboard:view"
              yes={() => <ListItemLink to="/queues" primary={i18n.t("mainDrawer.listItems.queues")} icon={<AccountTreeOutlinedIcon />} tooltip={collapsed} />}
            />

            {showIntegrations && (
              <Can role={user.profile} perform="dashboard:view"
                yes={() => <ListItemLink to="/queue-integration" primary={i18n.t("mainDrawer.listItems.queueIntegration")} icon={<DeviceHubOutlined />} tooltip={collapsed} />}
              />
            )}

            {showOpenAi && (
              <Can role={user.profile} perform="dashboard:view"
                yes={() => <ListItemLink to="/prompts" primary={i18n.t("mainDrawer.listItems.prompts")} icon={<AllInclusive />} tooltip={collapsed} />}
              />
            )}

            {showExternalApi && (
              <Can role={user.profile} perform="dashboard:view"
                yes={() => <ListItemLink to="/messages-api" primary={i18n.t("mainDrawer.listItems.messagesAPI")} icon={<CodeRoundedIcon />} tooltip={collapsed} />}
              />
            )}

            <Can role={user.profile} perform="dashboard:view"
              yes={() => <ListItemLink to="/settings" primary={i18n.t("mainDrawer.listItems.settings")} icon={<SettingsOutlinedIcon />} tooltip={collapsed} />}
            />

            <Can role={user.profile} perform="dashboard:view"
              yes={() => <ListItemLink to="/financeiro" primary={i18n.t("mainDrawer.listItems.financeiro")} icon={<LocalAtmIcon />} tooltip={collapsed} />}
            />

            {user.profile === "admin" && showWallets && (
              <ListItemLink to="/wallets" primary={i18n.t("mainDrawer.listItems.wallets")} icon={<AccountBalanceWalletIcon />} tooltip={collapsed} />
            )}

            <Can role={user.profile} perform="dashboard:view"
              yes={() => <ListItemLink to="/birthday-settings" primary={i18n.t("mainDrawer.listItems.birthdaySettings")} icon={<CakeIcon />} tooltip={collapsed} />}
            />

            {/* Solo superadmin */}
            {user.super && (
              <>
                <ListItemLink to="/announcements" primary={i18n.t("mainDrawer.listItems.annoucements")} icon={<AnnouncementIcon />} tooltip={collapsed} />
                <ListItemLink to="/allConnections" primary={i18n.t("mainDrawer.listItems.allConnections")} icon={<PhonelinkSetup />} tooltip={collapsed} />
                <ListItemLink to="/companies" primary={i18n.t("mainDrawer.listItems.companies")} icon={<BusinessIcon />} tooltip={collapsed} />
              </>
            )}

            {hasHelps && (
              <ListItemLink to="/helps" primary={i18n.t("mainDrawer.listItems.helps")} icon={<HelpOutlineIcon />} tooltip={collapsed} />
            )}
          </>
        )}
      />

      {/* Dashboard al fondo — acceso rápido para admins */}
      <Can
        role={user.profile === "user" && user.showDashboard === "enabled" ? "admin" : user.profile}
        perform="drawer-admin-items:view"
        yes={() => (
          <ListItemLink to="/" primary="Dashboard" icon={<DashboardOutlinedIcon />} tooltip={collapsed} />
        )}
      />

      {!collapsed && (
        <>
          <Divider style={{ margin: "8px 0", opacity: 0.3 }} />
          <Typography style={{ fontSize: "11px", padding: "8px 16px", textAlign: "center", fontWeight: 600, color: "#7C3AED", opacity: 0.7 }}>
            {version}
          </Typography>
        </>
      )}
    </div>
  );
};

export default MainListItems;
